import { render, staticRenderFns } from "./userProfile2.vue?vue&type=template&id=c7f7b0d8&scoped=true&"
import script from "./userProfile2.vue?vue&type=script&lang=js&"
export * from "./userProfile2.vue?vue&type=script&lang=js&"
import style0 from "./userProfile2.vue?vue&type=style&index=0&id=c7f7b0d8&scoped=true&lang=css&"
import style1 from "./userProfile2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f7b0d8",
  null
  
)

export default component.exports